"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTagCloud = void 0;

var react_1 = __importDefault(require("react"));

var react_tagcloud_1 = require("react-tagcloud"); // credits to: https://github.com/madox2/react-tagcloud


var StyledTagCloud = function StyledTagCloud(_a) {
  var list = _a.list,
      onClick = _a.onClick,
      theme = _a.theme;

  var style = function style(theme) {
    return "inline-flex justify-center items-center cursor-pointer w-24 px-2 py-1 mb-2 border ".concat(theme ? theme.body.borderColor : "border-transparent", " rounded ").concat(theme ? theme.body.textColor : "text-gray-800", " text-base leading-4 bg-transparent hover:text-gray-900 hover:bg-gray-100 hover:shadow-lg focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-transparent transition ease-in-out duration-150");
  };

  var customRenderer = function customRenderer(tag) {
    return react_1["default"].createElement("span", {
      className: "mr-2",
      key: tag.value
    }, react_1["default"].createElement("span", {
      key: tag.value,
      className: style(theme)
    }, tag.value));
  };

  return react_1["default"].createElement(react_tagcloud_1.TagCloud, {
    minSize: 24,
    maxSize: 24,
    tags: list,
    shuffle: false,
    onClick: onClick,
    renderer: customRenderer
  });
};

exports.StyledTagCloud = StyledTagCloud;